import { Role } from "@/types/lead";
import { api } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

export const useRoles = () => {
  return useQuery({
    queryKey: ["roles"],
    queryFn: async (): Promise<Role[]> => {
      const response = await api.get("/roles");
      return response.data;
    },
    staleTime: 2 * 60 * 1000,
  });
};
